import { Button } from "@nextiva/next-ui";
import moment from "moment-timezone";
import React, { Component } from "react";

// own
import DateRow from "./DateRow/DateRow";
import Styles from "./CustomOptions.module.scss";

class CustomOptions extends Component {
  static defaultProps = {
    onSave: () => {},
    onSaveCancel: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      start: moment.utc(props.start).tz(props.timezone),
      end: moment.utc(props.end).tz(props.timezone),
      errors: {},
    };
  }

  prepareChanges = (changes, field, newDate) => {
    const { hideEnd } = this.props;
    const { start, end } = this.state;
    if (!hideEnd && field === "start" && newDate.isAfter(end)) {
      changes.start = end;
      changes.end = newDate;
    } else if (field === "end" && newDate.isBefore(start)) {
      changes.start = newDate;
      changes.end = start;
    } else {
      changes[field] = newDate;
    }
  };

  handleDateChange = (field, newDate, hasError) => {
    const changes = {
      ...this.state,
      errors: {
        ...this.state.errors,
        [field]: hasError,
      },
      [field]: newDate,
    };

    if (!hasError) {
      this.prepareChanges(changes, field, newDate);
    }

    this.setState(changes);

    if (this.props.isScheduleMode && changes.start) {
      this.props.setScheduleStart && this.props.setScheduleStart(changes.start);
    }
  };

  handleSave = () => {
    const { hideEnd, onSaveCancel, onSave } = this.props;
    const { start, end, errors } = this.state;

    // check for errors in child components
    if (!start || !end || errors.start || errors.end) {
      return;
    }

    // check if start time is after end time
    if (hideEnd) {
      if (start.isAfter(moment())) {
        return onSaveCancel({ message: "Start time must be before now." });
      }
    } else {
      if (start.isAfter(end)) {
        return onSaveCancel({ message: "Start time must be before end time." });
      }
    }

    const dateRange = {
      type: "absolute",
      start: start.toISOString(),
      end: end.toISOString(),
    };

    onSave(dateRange);
  };

  render() {
    const { timezone, hideEnd, isScheduleMode, scheduleStart } = this.props;
    const { start, end } = this.state;

    return (
      <div className={Styles["drp-custom-options"]}>
        <DateRow
          className="drp-custom-options__start"
          label={!isScheduleMode ? "Start" : undefined}
          date={isScheduleMode ? scheduleStart : start}
          timezone={timezone}
          onChange={(newDate, hasError) =>
            this.handleDateChange("start", newDate, hasError)
          }
          datePicker={{
            selectsStart: true,
            startDate: start,
            endDate: end,
          }}
          isScheduleMode={isScheduleMode}
        />
        {!hideEnd && (
          <DateRow
            className={Styles["drp-custom-options__end"]}
            label="Ends"
            date={end}
            timezone={timezone}
            onChange={(newDate, hasError) =>
              this.handleDateChange("end", newDate, hasError)
            }
            datePicker={{
              selectsEnd: true,
              startDate: start,
              endDate: end,
            }}
          />
        )}
        <div className={Styles["drp-custom-options__footer"]}>
          {!isScheduleMode && (
            <Button
              kind="success"
              className="drp-popover__btn-update"
              onClick={this.handleSave}
              data-testid="AnalyticsSpa-CustomOptions-UpdateButton"
            >
              Update
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default CustomOptions;
